export const COUNTRY_LIST = [
	// Zone 1: North American Numbering Plan (NANP)
	{
		N: 'United States',
		D: '+1',
		C: 'US',
		F: [3, 3, 4],
	},
	// United States territories
	{
		N: 'United States Virgin Islands',
		D: '+1340',
		C: 'VI',
		F: [3, 4],
	},
	{
		N: 'Northern Mariana Islands',
		D: '+1670',
		C: 'MP',
		F: [3, 4],
	},
	{
		N: 'Guam',
		D: '+1671',
		C: 'GU',
		F: [3, 4],
	},
	{
		N: 'American Samoa',
		D: '+1684',
		C: 'AS',
		F: [3, 4],
	},
	{
		N: 'Puerto Rico',
		D: '+1',
		C: 'PR',
		F: [3, 3, 4],
		A: [787, 939],
	},
	//ends
	{
		N: 'Canada',
		D: '+1',
		C: 'CA',
		F: [3, 3, 4],
		A: [
			204, 226, 236, 249, 250, 257, 263, 289, 306, 343, 354, 365, 367, 368, 382, 387, 403,
			416, 418, 428, 431, 437, 438, 450, 460, 468, 474, 506, 514, 519, 537, 548, 568, 579,
			581, 584, 587, 604, 613, 639, 647, 672, 683, 705, 709, 742, 753, 778, 780, 782, 807,
			819, 825, 851, 867, 873, 879, 902, 905, 942,
		],
	},
	//Caribbean nations, Dutch and British Overseas Territories
	{
		N: 'Bahamas',
		D: '+1242',
		C: 'BS',
		F: [3, 4],
	},
	{
		N: 'Barbados',
		D: '+1246',
		C: 'BB',
		F: [3, 4],
	},
	{
		N: 'Anguilla',
		D: '+1264',
		C: 'AI',
		F: [3, 4],
	},
	{
		N: 'Antigua and Barbuda',
		D: '+1268',
		C: 'AG',
		F: [3, 4],
	},
	{
		N: 'British Virgin Islands',
		D: '+1284',
		C: 'VG',
		F: [3, 4],
	},
	{
		N: 'Cayman Islands',
		D: '+1345',
		C: 'KY',
		F: [3, 4],
	},
	{
		N: 'Bermuda',
		D: '+1441',
		C: 'BM',
		F: [3, 4],
	},
	{
		N: 'Grenada',
		D: '+1473',
		C: 'GD',
		F: [3, 4],
	},
	{
		N: 'Turks and Caicos Islands',
		D: '+1649',
		C: 'TC',
		F: [3, 4],
	},
	{
		N: 'Jamaica',
		D: '+1',
		C: 'JM',
		F: [3, 3, 4],
		A: [658, 876],
	},
	{
		N: 'Montserrat',
		D: '+1664',
		C: 'MS',
		F: [3, 4],
	},
	{
		N: 'Sint Maarten',
		D: '+1721',
		C: 'SX',
		F: [3, 4],
	},
	{
		N: 'Saint Lucia',
		D: '+1758',
		C: 'LC',
		F: [3, 4],
	},
	{
		N: 'Dominica',
		D: '+1767',
		C: 'DM',
		F: [3, 4],
	},
	{
		N: 'Saint Vincent and the Grenadines',
		D: '+1784',
		C: 'VC',
		F: [3, 4],
	},
	{
		N: 'Dominican Republic',
		D: '+1',
		C: 'DO',
		F: [3, 3, 4],
		A: [809, 829, 849],
	},
	{
		N: 'Trinidad and Tobago',
		D: '+1868',
		C: 'TT',
		F: [3, 4],
	},
	{
		N: 'Saint Kitts and Nevis',
		D: '+1869',
		C: 'KN',
		F: [3, 4],
	},
	// end
	// Zone 2: Mostly Africa
	// (but also Aruba, Faroe Islands, Greenland and British Indian Ocean Territory)
	{
		N: 'Egypt',
		D: '+20',
		C: 'EG',
		F: [2, 4, 4],
	},
	{
		N: 'South Africa',
		D: '+27',
		C: 'ZA',
		F: [2, 3, 4],
	},
	{
		N: 'South Sudan',
		D: '+211',
		C: 'SS',
		F: [],
	},
	{
		N: 'Morocco',
		D: '+212',
		C: 'MA',
		F: [],
	},
	{
		N: 'Algeria',
		D: '+213',
		C: 'DZ',
		F: [],
	},
	{
		N: 'Tunisia',
		D: '+216',
		C: 'TN',
		F: [],
	},
	{
		N: 'Libya',
		D: '+218',
		C: 'LY',
		F: [],
	},
	{
		N: 'Gambia',
		D: '+220',
		C: 'GM',
		F: [],
	},
	{
		N: 'Senegal',
		D: '+221',
		C: 'SN',
		F: [],
	},
	{
		N: 'Mauritania',
		D: '+222',
		C: 'MR',
		F: [],
	},
	{
		N: 'Mali',
		D: '+223',
		C: 'ML',
		F: [],
	},
	{
		N: 'Guinea',
		D: '+224',
		C: 'GN',
		F: [],
	},
	{
		N: "Cote d'Ivoire",
		D: '+225',
		C: 'CI',
		F: [],
	},
	{
		N: 'Burkina Faso',
		D: '+226',
		C: 'BF',
		F: [],
	},
	{
		N: 'Niger',
		D: '+227',
		C: 'NE',
		F: [],
	},
	{
		N: 'Togo',
		D: '+228',
		C: 'TG',
		F: [],
	},
	{
		N: 'Benin',
		D: '+229',
		C: 'BJ',
		F: [],
	},
	{
		N: 'Mauritius',
		D: '+230',
		C: 'MU',
		F: [],
	},
	{
		N: 'Liberia',
		D: '+231',
		C: 'LR',
		F: [],
	},
	{
		N: 'Sierra Leone',
		D: '+232',
		C: 'SL',
		F: [],
	},
	{
		N: 'Ghana',
		D: '+233',
		C: 'GH',
		F: [],
	},
	{
		N: 'Nigeria',
		D: '+234',
		C: 'NG',
		F: [],
	},
	{
		N: 'Chad',
		D: '+235',
		C: 'TD',
		F: [],
	},
	{
		N: 'Central African Republic',
		D: '+236',
		C: 'CF',
		F: [],
	},
	{
		N: 'Cameroon',
		D: '+237',
		C: 'CM',
		F: [],
	},
	{
		N: 'Cape Verde',
		D: '+238',
		C: 'CV',
		F: [],
	},
	{
		N: 'Sao Tome and Principe',
		D: '+239',
		C: 'ST',
		F: [],
	},
	{
		N: 'Equatorial Guinea',
		D: '+240',
		C: 'GQ',
		F: [],
	},
	{
		N: 'Gabon',
		D: '+241',
		C: 'GA',
		F: [],
	},
	{
		N: 'Congo',
		D: '+242',
		C: 'CG',
		F: [],
	},
	{
		N: 'Democratic Republic of the Congo',
		D: '+243',
		C: 'CD',
		F: [],
	},
	{
		N: 'Angola',
		D: '+244',
		C: 'AO',
		F: [],
	},
	{
		N: 'Guinea-Bissau',
		D: '+245',
		C: 'GW',
		F: [],
	},
	{
		N: 'British Indian Ocean Territory',
		D: '+246',
		C: 'IO',
		F: [],
	},
	{
		N: 'Ascension Island',
		D: '+247',
		C: 'SH-AC',
		F: [],
	},
	{
		N: 'Seychelles',
		D: '+248',
		C: 'SC',
		F: [],
	},
	{
		N: 'Sudan',
		D: '+249',
		C: 'SD',
		F: [],
	},
	{
		N: 'Rwanda',
		D: '+250',
		C: 'RW',
		F: [],
	},
	{
		N: 'Ethiopia',
		D: '+251',
		C: 'ET',
		F: [],
	},
	{
		N: 'Somalia',
		D: '+252',
		C: 'SO',
		F: [],
	},
	{
		N: 'Djibouti',
		D: '+253',
		C: 'DJ',
		F: [],
	},
	{
		N: 'Kenya',
		D: '+254',
		C: 'KE',
		F: [],
	},
	{
		N: 'Tanzania',
		D: '+255',
		C: 'TZ',
		F: [],
	},
	{
		N: 'Uganda',
		D: '+256',
		C: 'UG',
		F: [],
	},
	{
		N: 'Burundi',
		D: '+257',
		C: 'BI',
		F: [],
	},
	{
		N: 'Mozambique',
		D: '+258',
		C: 'MZ',
		F: [],
	},
	{
		N: 'Zambia',
		D: '+260',
		C: 'ZM',
		F: [],
	},
	{
		N: 'Madagascar',
		D: '+261',
		C: 'MG',
		F: [],
	},
	// problemetic
	{
		N: 'Mayotte',
		D: '+262',
		C: 'YT',
		F: [3, 2, 2, 2],
	},
	{
		N: 'Reunion',
		D: '+262',
		C: 'RE',
		F: [3, 2, 2, 2],
	},
	{
		N: 'Zimbabwe',
		D: '+263',
		C: 'ZW',
		F: [],
	},
	{
		N: 'Namibia',
		D: '+264',
		C: 'NA',
		F: [],
	},
	{
		N: 'Malawi',
		D: '+265',
		C: 'MW',
		F: [],
	},
	{
		N: 'Lesotho',
		D: '+266',
		C: 'LS',
		F: [],
	},
	{
		N: 'Botswana',
		D: '+267',
		C: 'BW',
		F: [],
	},
	{
		N: 'Eswatini',
		D: '+268',
		C: 'SZ',
		F: [],
	},
	{
		N: 'Comoros',
		D: '+269',
		C: 'KM',
		F: [],
	},
	{
		N: 'Saint Helena, Ascension and Tristan Da Cunha',
		D: '+290',
		C: 'SH',
		F: [],
	},
	{
		N: 'Eritrea',
		D: '+291',
		C: 'ER',
		F: [],
	},
	{
		N: 'Aruba',
		D: '+297',
		C: 'AW',
		F: [],
	},
	{
		N: 'Faroe Islands',
		D: '+298',
		C: 'FO',
		F: [],
	},
	{
		N: 'Greenland',
		D: '+299',
		C: 'GL',
		F: [],
	},
	// Zones 3–4: Europe
	{
		N: 'Greece',
		D: '+30',
		C: 'GR',
		F: [3, 3, 4],
	},
	{
		N: 'Netherlands',
		D: '+31',
		C: 'NL',
		F: [2, 3, 4],
	},
	{
		N: 'Belgium',
		D: '+32',
		C: 'BE',
		F: [2, 3, 2, 2],
	},
	{
		N: 'France',
		D: '+33',
		C: 'FR',
		F: [1, 2, 2, 2, 2],
	},
	{
		N: 'Spain',
		D: '+34',
		C: 'ES',
		F: [3, 2, 2, 2],
	},
	{
		N: 'Gibraltar',
		D: '+350',
		C: 'GI',
		F: [],
	},
	{
		N: 'Portugal',
		D: '+351',
		C: 'PT',
		F: [],
	},
	{
		N: 'Luxembourg',
		D: '+352',
		C: 'LU',
		F: [],
	},
	{
		N: 'Ireland',
		D: '+353',
		C: 'IE',
		F: [],
	},
	{
		N: 'Iceland',
		D: '+354',
		C: 'IS',
		F: [],
	},
	{
		N: 'Albania',
		D: '+355',
		C: 'AL',
		F: [],
	},
	{
		N: 'Malta',
		D: '+356',
		C: 'MT',
		F: [],
	},
	{
		N: 'Cyprus',
		D: '+357',
		C: 'CY',
		F: [],
	},
	{
		N: 'Finland',
		D: '+358',
		C: 'FI',
		F: [],
	},
	{
		N: 'Åland',
		D: '+35818',
		C: 'AX',
		F: [],
	},
	{
		N: 'Bulgaria',
		D: '+359',
		C: 'BG',
		F: [],
	},
	{
		N: 'Hungary',
		D: '+36',
		C: 'HU',
		F: [2, 3, 4],
	},
	{
		N: 'Lithuania',
		D: '+370',
		C: 'LT',
		F: [],
	},
	{
		N: 'Latvia',
		D: '+371',
		C: 'LV',
		F: [],
	},
	{
		N: 'Estonia',
		D: '+372',
		C: 'EE',
		F: [],
	},
	{
		N: 'Moldova, Republic of',
		D: '+373',
		C: 'MD',
		F: [],
	},
	{
		N: 'Armenia',
		D: '+374',
		C: 'AM',
		F: [],
	},
	{
		N: 'Belarus',
		D: '+375',
		C: 'BY',
		F: [],
	},
	{
		N: 'Andorra',
		D: '+376',
		C: 'AD',
		F: [],
	},
	{
		N: 'Monaco',
		D: '+377',
		C: 'MC',
		F: [],
	},
	{
		N: 'San Marino',
		D: '+378', // interchangeably with 39 0549
		C: 'SM',
		F: [],
	},
	{
		N: 'Holy See (Vatican City State)',
		D: '+3906698', //'+379' assign but not in used,
		C: 'VA',
		F: [],
	},
	{
		N: 'Ukraine',
		D: '+380',
		C: 'UA',
		F: [],
	},
	{
		N: 'Serbia',
		D: '+381',
		C: 'RS',
		F: [],
	},
	{
		N: 'Montenegro',
		D: '+382',
		C: 'ME',
		F: [],
	},
	{
		N: 'Kosovo',
		D: '+383',
		C: 'XK',
		F: [],
	},
	{
		N: 'Croatia',
		D: '+385',
		C: 'HR',
		F: [],
	},
	{
		N: 'Slovenia',
		D: '+386',
		C: 'SI',
		F: [],
	},
	{
		N: 'Bosnia and Herzegovina',
		D: '+387',
		C: 'BA',
		F: [],
	},
	{
		N: 'North Macedonia',
		D: '+389',
		C: 'MK',
		F: [],
	},
	{
		N: 'Italy',
		D: '+39',
		C: 'IT',
		F: [],
	},
	// {
	// 	N: 'San Marino',
	// 	D: '+390549',
	// 	C: 'SM',
	// 	F: [],
	// },
	{
		N: 'Romania',
		D: '+40',
		C: 'RO',
		F: [],
	},
	{
		N: 'Switzerland',
		D: '+41',
		C: 'CH',
		F: [],
	},
	{
		N: 'Czech Republic',
		D: '+420',
		C: 'CZ',
		F: [],
	},
	{
		N: 'Slovakia',
		D: '+421',
		C: 'SK',
		F: [],
	},
	{
		N: 'Liechtenstein',
		D: '+423',
		C: 'LI',
		F: [],
	},
	{
		N: 'Austria',
		D: '+43',
		C: 'AT',
		F: [],
	},
	{
		N: 'United Kingdom',
		D: '+44',
		C: 'GB',
		F: [5, 5],
	},
	{
		N: 'Guernsey',
		D: '+44',
		C: 'GG',
		F: [],
		A: [1481],
	},
	{
		N: 'Isle of Man',
		D: '+44',
		C: 'IM',
		F: [],
		A: [1534],
	},
	{
		N: 'Jersey',
		D: '+44',
		C: 'JE',
		F: [],
		A: [1624],
	},
	{
		N: 'Denmark',
		D: '+45',
		C: 'DK',
		F: [],
	},
	{
		N: 'Sweden',
		D: '+46',
		C: 'SE',
		F: [],
	},
	{
		N: 'Norway',
		D: '+47',
		C: 'NO',
		F: [2, 2, 2, 2],
	},
	{
		N: 'Svalbard',
		D: '+47',
		C: 'SJ',
		F: [2, 2, 2, 2],
		A: [79],
	},
	{
		N: 'Poland',
		D: '+48',
		C: 'PL',
		F: [],
	},
	{
		N: 'Germany',
		D: '+49',
		C: 'DE',
		F: [],
	},

	// Zone 5: South and Central Americas

	// problemetic
	{
		N: 'Falkland Islands (Malvinas)',
		D: '+500',
		C: 'FK',
		F: [],
	},
	{
		N: 'South Georgia and the South Sandwich Islands',
		D: '+500',
		C: 'GS',
		F: [],
	},
	{
		N: 'Belize',
		D: '+501',
		C: 'BZ',
		F: [],
	},
	{
		N: 'Guatemala',
		D: '+502',
		C: 'GT',
		F: [],
	},
	{
		N: 'El Salvador',
		D: '+503',
		C: 'SV',
		F: [],
	},
	{
		N: 'Honduras',
		D: '+504',
		C: 'HN',
		F: [],
	},
	{
		N: 'Nicaragua',
		D: '+505',
		C: 'NI',
		F: [],
	},
	{
		N: 'Costa Rica',
		D: '+506',
		C: 'CR',
		F: [],
	},
	{
		N: 'Panama',
		D: '+507',
		C: 'PA',
		F: [],
	},
	{
		N: 'Saint Pierre and Miquelon',
		D: '+508',
		C: 'PM',
		F: [],
	},
	{
		N: 'Haiti',
		D: '+509',
		C: 'HT',
		F: [],
	},
	{
		N: 'Peru',
		D: '+51',
		C: 'PE',
		F: [],
	},
	{
		N: 'Mexico',
		D: '+52',
		C: 'MX',
		F: [],
	},
	{
		N: 'Cuba',
		D: '+53',
		C: 'CU',
		F: [],
	},
	{
		N: 'Argentina',
		D: '+54',
		C: 'AR',
		F: [],
	},
	{
		N: 'Brazil',
		D: '+55',
		C: 'BR',
		F: [],
	},
	{
		N: 'Chile',
		D: '+56',
		C: 'CL',
		F: [],
	},
	{
		N: 'Colombia',
		D: '+57',
		C: 'CO',
		F: [],
	},
	{
		N: 'Venezuela',
		D: '+58',
		C: 'VE',
		F: [],
	},
	// problemetic
	{
		N: 'Guadeloupe',
		D: '+590',
		C: 'GP',
		F: [],
	},
	{
		N: 'Saint Barthelemy',
		D: '+590',
		C: 'BL',
		F: [],
	},
	{
		N: 'Saint Martin',
		D: '+590',
		C: 'MF',
		F: [],
	},
	{
		N: 'Bolivia',
		D: '+591',
		C: 'BO',
		F: [],
	},
	{
		N: 'Guyana',
		D: '+592',
		C: 'GY',
		F: [],
	},
	{
		N: 'Ecuador',
		D: '+593',
		C: 'EC',
		F: [],
	},
	{
		N: 'French Guiana',
		D: '+594',
		C: 'GF',
		F: [],
	},
	{
		N: 'Paraguay',
		D: '+595',
		C: 'PY',
		F: [],
	},
	{
		N: 'Martinique',
		D: '+596',
		C: 'MQ',
		F: [],
	},
	{
		N: 'SuriN',
		D: '+597',
		C: 'SR',
		F: [],
	},
	{
		N: 'Uruguay',
		D: '+598',
		C: 'UY',
		F: [],
	},
	{
		N: 'Netherlands Antilles',
		D: '+599',
		C: 'AN',
		F: [],
	},

	//  Zone 6: Southeast Asia and Oceania
	{ N: 'Malaysia', D: '+60', C: 'MY', F: [2, 4, 4] },
	{
		N: 'Australia',
		D: '+61',
		C: 'AU',
		F: [3, 3, 3],
	},
	{
		N: 'Christmas Island',
		D: '+61',
		C: 'CX',
		F: [],
		A: [89164],
	},
	{
		N: 'Cocos (Keeling) Islands',
		D: '+61',
		C: 'CC',
		F: [],
		A: [89162],
	},
	{
		N: 'Indonesia',
		D: '+62',
		C: 'ID',
		F: [],
	},
	{
		N: 'Philippines',
		D: '+63',
		C: 'PH',
		F: [],
	},
	{
		N: 'New Zealand',
		D: '+64',
		C: 'NZ',
		F: [],
	},
	{
		N: 'Singapore',
		D: '+65',
		C: 'SG',
		F: [],
	},
	{
		N: 'Thailand',
		D: '+66',
		C: 'TH',
		F: [],
	},
	{
		N: 'East Timor',
		D: '+670',
		C: 'TL',
		F: [],
	},
	{
		N: 'Antarctica',
		D: '+672',
		C: 'AQ',
		F: [1, 2, 3],
		A: [1],
	},
	{
		N: 'Norfolk Island',
		D: '+672',
		C: 'NF',
		F: [2, 4],
		A: [3],
	},
	{
		N: 'Brunei',
		D: '+673',
		C: 'BN',
		F: [],
	},
	{
		N: 'Nauru',
		D: '+674',
		C: 'NR',
		F: [],
	},
	{
		N: 'Papua New Guinea',
		D: '+675',
		C: 'PG',
		F: [],
	},
	{
		N: 'Tonga',
		D: '+676',
		C: 'TO',
		F: [],
	},
	{
		N: 'Solomon Islands',
		D: '+677',
		C: 'SB',
		F: [],
	},
	{
		N: 'Vanuatu',
		D: '+678',
		C: 'VU',
		F: [],
	},
	{
		N: 'Fiji',
		D: '+679',
		C: 'FJ',
		F: [],
	},
	{
		N: 'Palau',
		D: '+680',
		C: 'PW',
		F: [],
	},
	{
		N: 'Wallis and Futuna',
		D: '+681',
		C: 'WF',
		F: [],
	},
	{
		N: 'Cook Islands',
		D: '+682',
		C: 'CK',
		F: [],
	},
	{
		N: 'Niue',
		D: '+683',
		C: 'NU',
		F: [],
	},
	{
		N: 'Samoa',
		D: '+685',
		C: 'WS',
		F: [],
	},
	{
		N: 'Kiribati',
		D: '+686',
		C: 'KI',
		F: [],
	},
	{
		N: 'New Caledonia',
		D: '+687',
		C: 'NC',
		F: [],
	},
	{
		N: 'Tuvalu',
		D: '+688',
		C: 'TV',
		F: [],
	},
	{
		N: 'French Polynesia',
		D: '+689',
		C: 'PF',
		F: [],
	},
	{
		N: 'Tokelau',
		D: '+690',
		C: 'TK',
		F: [],
	},
	{
		N: 'Micronesia, Federated States of',
		D: '+691',
		C: 'FM',
		F: [],
	},
	{
		N: 'Marshall Islands',
		D: '+692',
		C: 'MH',
		F: [],
	},
	// Zone 7: Russia and neighboring regions

	{
		N: 'Russia',
		D: '+7',
		C: 'RU',
		F: [3, 3, 2, 2],
	},
	{
		N: 'Kazakhstan',
		D: '+7',
		C: 'KZ',
		F: [3, 3, 2, 2],
		A: [7, 6],
	},
	// Zone 8: East Asia, South Asia and special services
	{
		N: 'Japan',
		D: '+81',
		C: 'JP',
		F: [],
	},
	{
		N: 'South Korea',
		D: '+82',
		C: 'KR',
		F: [],
	},
	{
		N: 'Vietnam',
		D: '+84',
		C: 'VN',
		F: [],
	},
	{
		N: 'North Korea',
		D: '+850',
		C: 'KP',
		F: [],
	},
	{
		N: 'Hong Kong',
		D: '+852',
		C: 'HK',
		F: [],
	},
	{
		N: 'Macao',
		D: '+853',
		C: 'MO',
		F: [],
	},
	{
		N: 'Cambodia',
		D: '+855',
		C: 'KH',
		F: [],
	},
	{
		N: 'Laos',
		D: '+856',
		C: 'LA',
		F: [],
	},
	{
		N: 'China',
		D: '+86',
		C: 'CN',
		F: [3, 4, 4],
	},
	{
		N: 'Bangladesh',
		D: '+880',
		C: 'BD',
		F: [],
	},
	{
		N: 'Taiwan',
		D: '+886',
		C: 'TW',
		F: [],
	},

	// Zone 9: Mostly Middle East, West Asia, Central Asia, parts of South Asia and Eastern Europe
	{
		N: 'Turkey',
		D: '+90',
		C: 'TR',
		F: [],
	},
	{
		N: 'India',
		D: '+91',
		C: 'IN',
		F: [5, 5],
	},
	{
		N: 'Pakistan',
		D: '+92',
		C: 'PK',
		F: [3, 7],
	},
	{
		N: 'Afghanistan',
		D: '+93',
		C: 'AF',
		F: [],
	},
	{
		N: 'Sri Lanka',
		D: '+94',
		C: 'LK',
		F: [],
	},
	{
		N: 'Myanmar',
		D: '+95',
		C: 'MM',
		F: [],
	},
	{
		N: 'Maldives',
		D: '+960',
		C: 'MV',
		F: [],
	},
	{
		N: 'Lebanon',
		D: '+961',
		C: 'LB',
		F: [],
	},
	{
		N: 'Jordan',
		D: '+962',
		C: 'JO',
		F: [],
	},
	{
		N: 'Syria',
		D: '+963',
		C: 'SY',
		F: [],
	},
	{
		N: 'Iraq',
		D: '+964',
		C: 'IQ',
		F: [],
	},
	{
		N: 'Kuwait',
		D: '+965',
		C: 'KW',
		F: [],
	},
	{
		N: 'Saudi Arabia',
		D: '+966',
		C: 'SA',
		F: [],
	},
	{
		N: 'Yemen',
		D: '+967',
		C: 'YE',
		F: [],
	},
	{
		N: 'Oman',
		D: '+968',
		C: 'OM',
		F: [],
	},
	{
		N: 'Palestinian Territory, Occupied',
		D: '+970',
		C: 'PS',
		F: [],
	},
	{
		N: 'United Arab Emirates',
		D: '+971',
		C: 'AE',
		F: [],
	},
	{
		N: 'Israel',
		D: '+972',
		C: 'IL',
		F: [],
	},
	{
		N: 'Bahrain',
		D: '+973',
		C: 'BH',
		F: [],
	},
	{
		N: 'Qatar',
		D: '+974',
		C: 'QA',
		F: [],
	},
	{
		N: 'Bhutan',
		D: '+975',
		C: 'BT',
		F: [],
	},
	{
		N: 'Mongolia',
		D: '+976',
		C: 'MN',
		F: [],
	},
	{
		N: 'Nepal',
		D: '+977',
		C: 'NP',
		F: [],
	},
	{
		N: 'Iran',
		D: '+98',
		C: 'IR',
		F: [],
	},
	{
		N: 'Tajikistan',
		D: '+992',
		C: 'TJ',
		F: [],
	},
	{
		N: 'Turkmenistan',
		D: '+993',
		C: 'TM',
		F: [],
	},
	{
		N: 'Azerbaijan',
		D: '+994',
		C: 'AZ',
		F: [],
	},
	{
		N: 'Georgia',
		D: '+995',
		C: 'GE',
		F: [],
	},
	{
		N: 'Kyrgyzstan',
		D: '+996',
		C: 'KG',
		F: [],
	},
	{
		N: 'Uzbekistan',
		D: '+998',
		C: 'UZ',
		F: [],
	},
];
